export function escapeForTemplateString(originalText) {
    return originalText.replace(/([$`\\])/g, '\\$1').replace(/\r/g, '\\r');
}
export function escapeForMultilineComments(originalText) {
    return originalText.replace(/\*\//g, '*\\/');
}
